var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.4062 15.375C35.75 15.75 4.40625 45.75 3.21875 47.1562C2.5 47.9688 2.5 48.0625 2.5 58.2188V68.4688L3.28125 69.2188L4.03125 70H40H75.9688L76.7188 69.2188L77.5 68.4688V42.5V16.5312L76.7188 15.7812L75.9688 15H56.5C42.4062 15.0312 36.875 15.125 36.4062 15.375ZM72.5 42.5V65H40H7.5V57.4062V49.8438L23.0625 34.9375L38.5938 20H55.5625H72.5V42.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.062 24.9063C38.4058 25.125 35.4058 28.0625 32.437 31.375C30.1558 33.875 29.937 34.2188 30.1245 35.125C30.3745 36.3438 31.3433 37.1875 32.5933 37.1875C33.437 37.1875 34.187 36.5625 37.8745 32.875C41.812 28.9375 42.187 28.4688 42.187 27.4375C42.187 25.6563 40.562 24.3438 39.062 24.9063Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5619 30.0313C56.1244 30.2188 50.6869 35.4375 44.4681 41.6563C32.1556 53.9375 32.2494 53.8438 33.9056 55.4688C34.4056 56 34.9994 56.25 35.6869 56.25C36.6244 56.25 37.7806 55.2188 48.3744 44.75C60.9681 32.375 60.8431 32.5313 59.3119 30.8125C58.4369 29.875 57.5931 29.625 56.5619 30.0313Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2187 47.5C63.875 47.625 61.6562 49.7188 59.3125 52.0938C55.5625 55.875 55 56.5938 55 57.4688C55 59.3125 57.0937 60.5625 58.7187 59.6875C59.0312 59.5313 61.125 57.4375 63.4062 55.0313C68.0312 50.0938 68.2812 49.4688 66.5312 48C65.5312 47.125 65.2187 47.0625 64.2187 47.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarWindow);
export default __webpack_public_path__ + "static/media/car-window.ceb7ec2f505691483a6ea06a5fb52da7.svg";
export { ForwardRef as ReactComponent };